import { Node } from '@tiptap/core';
import { isHttpUrl } from './sanitize';

export interface IframeOptions {
    allowFullscreen: boolean,
    HTMLAttributes: {
        [key: string]: any
    },
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        iframe: {
            setIframe: (options: { src: string }) => ReturnType,
        }
    }
}

export default Node.create<IframeOptions>({
    name: 'iframe',
    group: 'block',
    atom: true,

    addOptions() {
        return {
            allowFullscreen: true,
            HTMLAttributes: {
                class: 'iframe-wrapper',
            },
        }
    },

    addAttributes() {
        return {
            src: {
                default: null,
                // Only an absolute http(s) URL is ever rendered as the source.
                renderHTML: (attributes) =>
                    isHttpUrl(attributes.src) ? { src: attributes.src.trim() } : {},
            },
            frameborder: {
                default: 0,
            },
            allowfullscreen: {
                default: this.options.allowFullscreen,
                parseHTML: () => this.options.allowFullscreen,
            },
            sandbox: {
                default: 'allow-scripts allow-forms allow-top-navigation allow-presentation allow-same-origin allow-popups',
            },
        }
    },

    parseHTML() {
        return [{
            tag: 'iframe',
        }]
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', this.options.HTMLAttributes, ['iframe', HTMLAttributes]]
    },

    renderText() {
        return '';
    },

    addCommands() {
        return {
            setIframe: (options: { src: string }) => ({ tr, dispatch }) => {
                const { selection } = tr
                const node = this.type.create(options)

                if (dispatch) {
                    tr.replaceRangeWith(selection.from, selection.to, node)
                }

                return true
            },
        }
    },
})